/* Nid de Laine — scripts du thème */
(function () {
  'use strict';

  /* Menu mobile */
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-menu-open]');
    var close = e.target.closest('[data-menu-close]');
    var menu = document.getElementById('MobileMenu');
    if (!menu) return;
    if (open) { menu.classList.add('is-open'); menu.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
    if (close) { menu.classList.remove('is-open'); menu.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
  });

  /* Barre d'annonce rotative */
  document.querySelectorAll('[data-announcement]').forEach(function (bar) {
    var items = bar.querySelectorAll('.announcement__item');
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4500);
  });

  /* Apparition au défilement */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -60px 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* Compteur panier */
  function updateCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.setAttribute('data-count', cart.item_count);
        });
      });
  }

  function showToast() {
    var t = document.getElementById('CartToast');
    if (!t) return;
    t.hidden = false;
    clearTimeout(t._timer);
    t._timer = setTimeout(function () { t.hidden = true; }, 4000);
  }

  /* Bundle « Complétez votre lot » */
  function bundleMoney(cents, fmt) {
    var v = (cents / 100).toFixed(2);
    return (fmt || '{{amount_with_comma_separator}} €')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount\s*\}\}/, v);
  }
  function getBundleItems(form) {
    var root = form.closest('[data-product]');
    var b = root && root.querySelector('[data-bundle]');
    if (!b) return null;
    var tier = b.querySelector('input[type=radio]:checked');
    if (!tier || tier.value === '1') return null;
    var mainId = form.querySelector('[name=id]').value;
    var items = [{ id: Number(mainId), quantity: 1 }];
    b.querySelectorAll('[data-picks="' + tier.value + '"] select').forEach(function (sel) {
      items.push({ id: Number(sel.value), quantity: 1 });
    });
    return items;
  }
  document.querySelectorAll('[data-bundle]').forEach(function (b) {
    var tpl = b.querySelector('[data-bundle-select]');
    var base = Number(b.getAttribute('data-base'));
    var fmt = b.getAttribute('data-money');
    var line = b.querySelector('[data-save-line]');
    var form = b.closest('[data-product]') && b.closest('[data-product]').querySelector('form[data-main-form]');
    var mainBtnLabel = form && form.querySelector('[data-add-label]');
    var defaultLabel = mainBtnLabel ? mainBtnLabel.textContent : '';
    ['2', '3'].forEach(function (n) {
      var holder = b.querySelector('[data-picks="' + n + '"]');
      if (!holder) return;
      for (var i = 0; i < Number(n) - 1; i++) {
        var sel = tpl.content.firstElementChild.cloneNode(true);
        if (sel.options.length > i) sel.selectedIndex = i;
        holder.appendChild(sel);
      }
    });
    function update() {
      var tier = b.querySelector('input[type=radio]:checked').value;
      b.querySelectorAll('.bundle__opt').forEach(function (o) { o.classList.toggle('is-active', o.querySelector('input').checked); });
      ['2', '3'].forEach(function (n) {
        var holder = b.querySelector('[data-picks="' + n + '"]');
        if (!holder) return;
        var full = base;
        holder.querySelectorAll('select').forEach(function (sel) { full += Number(sel.selectedOptions[0].getAttribute('data-price')); });
        var pct = Number(b.getAttribute('data-p' + n));
        var now = Math.round(full * (100 - pct) / 100);
        b.querySelector('[data-tier-price="' + n + '"]').textContent = bundleMoney(now, fmt);
        b.querySelector('[data-tier-full="' + n + '"]').textContent = bundleMoney(full, fmt);
        if (tier === n) {
          line.hidden = false;
          line.textContent = 'Vous économisez ' + bundleMoney(full - now, fmt);
          if (mainBtnLabel) mainBtnLabel.textContent = 'Ajouter les ' + n + ' tutoriels';
        }
      });
      if (tier === '1') { line.hidden = true; if (mainBtnLabel) mainBtnLabel.textContent = defaultLabel; }
    }
    b.addEventListener('change', update);
    update();
  });

  /* Ajout au panier en AJAX */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type=submit]');
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Ajout…'; }
    var bundleItems = getBundleItems(form);
    fetch(window.routes.cart_add_url + '.js', bundleItems ? {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: bundleItems })
    } : {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) { alert(res.data.description || "Impossible d'ajouter ce produit."); return; }
        if (form.hasAttribute('data-redirect-cart')) { window.location = window.routes.cart_url; return; }
        updateCount();
        showToast();
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) { btn.disabled = false; btn.innerHTML = label; } });
  });

  /* Page produit */
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var dataEl = root.querySelector('[data-product-json]');
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var idInput = root.querySelector('[name=id]');
    var priceEl = root.querySelector('[data-price]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var buttons = root.querySelectorAll('[data-add-button]');
    var mainImg = root.querySelector('.gallery__img');
    var money = root.getAttribute('data-money-format') || '{{amount_with_comma_separator}} €';

    function formatMoney(cents) {
      var v = (cents / 100).toFixed(2);
      var withComma = v.replace('.', ',');
      return money
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(cents / 100))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
        .replace(/\{\{\s*amount\s*\}\}/, v);
    }

    function currentOptions() {
      return Array.prototype.map.call(root.querySelectorAll('[data-option-group]'), function (g) {
        var c = g.querySelector('input:checked');
        return c ? c.value : null;
      });
    }

    function onChange() {
      var opts = currentOptions();
      var v = product.variants.find(function (variant) {
        return variant.options.every(function (o, i) { return o === opts[i]; });
      });
      buttons.forEach(function (b) {
        b.disabled = !v || !v.available;
        var t = b.querySelector('[data-add-label]');
        if (t) t.textContent = !v ? 'Indisponible' : (v.available ? b.getAttribute('data-label') : 'Épuisé');
      });
      if (!v) return;
      idInput.value = v.id;
      var html = '<span>' + formatMoney(v.price) + '</span>';
      if (v.compare_at_price && v.compare_at_price > v.price) {
        html = '<span>' + formatMoney(v.price) + '</span><s>' + formatMoney(v.compare_at_price) + '</s><span class="price__save">−' + formatMoney(v.compare_at_price - v.price) + '</span>';
      }
      if (priceEl) priceEl.innerHTML = '<div class="price">' + html + '</div>';
      if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
      if (v.featured_image && mainImg) { mainImg.src = v.featured_image.src; mainImg.removeAttribute('srcset'); }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    root.querySelectorAll('[data-option-group] input').forEach(function (inp) { inp.addEventListener('change', onChange); });

    /* Galerie */
    root.querySelectorAll('[data-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!mainImg) return;
        mainImg.src = btn.getAttribute('data-src');
        mainImg.removeAttribute('srcset');
        mainImg.alt = btn.getAttribute('data-alt') || '';
        root.querySelectorAll('[data-thumb]').forEach(function (b) { b.setAttribute('aria-current', 'false'); });
        btn.setAttribute('aria-current', 'true');
      });
    });

    /* Quantité */
    root.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = parseInt(input.value, 10) || 1;
          n += b.hasAttribute('data-plus') ? 1 : -1;
          input.value = Math.max(1, n);
        });
      });
    });
  });

  /* Barre d'achat collante (mobile) */
  var sticky = document.querySelector('[data-sticky-atc]');
  var mainBtn = document.querySelector('[data-main-atc]');
  if (sticky && mainBtn && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      sticky.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
    }).observe(mainBtn);
    sticky.querySelector('button').addEventListener('click', function () {
      var form = document.querySelector('form[data-ajax-cart][data-main-form]');
      if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  }

  /* Tri collection */
  document.querySelectorAll('[data-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      window.location = url.toString();
    });
  });
})();
